module.exports = __webpack_public_path__ + "img/USER.c8b731ef.svg";